import "../../style.css";
import Header from "../Header";
import Footer from "../Footer";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Outlet } from "react-router-dom";

const ContentLayout = () => {
  const GoogleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  return (
    <>
      {/* {--------    Header section ---------  } */}
      <GoogleOAuthProvider clientId={`${GoogleClientId}`}>
        <Header />
      </GoogleOAuthProvider>

      {/* {--------    Policy section ---------  } */}
      <Outlet />

      {/* {--------    Footer section ---------  } */}
      <Footer />
    </>
  );
};

export default ContentLayout;
